var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bindList"},_vm._l((_vm.list),function(item,ind){return _c('el-card',{key:ind,staticClass:"listItem",nativeOn:{"click":function($event){return _vm.bindItem(item)}}},[_c('p',[_vm._v("姓名："+_vm._s(item.name))]),_vm._v(" "),_c('p',[_vm._v("地址："+_vm._s(item.address))])])}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-351db39e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/yhBind/bindList.vue
// module id = null
// module chunks = 